export default __webpack_public_path__ + "static/media/sendImage.e8158a44.svg";